import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import ForYouContent from './Content';
import type { ForYouProps } from './interfaces';

const queryClient = new QueryClient();

const ForYou = ({
  bookmarks,
  env,
  headlineVariant,
  initialCurrentUser,
  isGdprRequired,
  isNativeApp,
  isWebview,
  nativeAppVersion,
  newsletterNames,
}: ForYouProps) => {
  const { Track } = useEventTracking({
    page: Page.ForYou,
  });

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isNativeApp={isNativeApp}
      isWebview={isWebview}
      nativeAppVersion={nativeAppVersion}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <ForYouContent
            bookmarks={bookmarks}
            headlineVariant={headlineVariant}
            initialCurrentUser={initialCurrentUser}
            newsletterNames={newsletterNames}
          />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default ForYou;
